import { useContext, useCallback } from 'react';
import _get from 'lodash/get';
import { AjaxContext, AppContext, formatListData } from 'commons-ui';
import { IUpdateMessageCenterCardReq, ICreateMessageCenterCardReq } from 'commons/models/helpdesk.model';
import { SERVICE_NAMES } from 'commons-ui/src/settingsV2Enum';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const {
		app: { appName }
	} = useContext(AppContext);

	const deHydrateData = (data: any) => ({
		isActive: data.isActive,
		en: data.description.en,
		hi: data.description.hi,
		category: data.category,
		id: data._id
	});

	const hydrateData = (data: {
		isActive: boolean;
		en: string;
		hi: string;
		id: string;
		category: string;
		email: string;
		isActiveUpdated: boolean;
	}) => ({
		isActive: data.isActive,
		description: { en: data.en, hi: data.hi },
		id: data.id,
		category: data.category,
		email: data.email,
		isActiveUpdated: data.isActiveUpdated
	});
	const urlPrefix: string = '/dashboard/forward/miscellaneous-messageCenter';
	const getAllCardsForMessageCenter = useCallback(async () => {
		const result = await postData({
			endpoint: `${urlPrefix}-getAllCardsForMessageCenter`,
			queryParams: {
				appName
			},
			body: {
				forwardReqRoute: '/helpdesk/getAllCardsForMessageCenter',
				forwardReqToService: SERVICE_NAMES.HELPDESK
			}
		});
		const data = _get(result, ['data', 'cards']);
		return { rowCount: data.length, data: formatListData(data) };
	}, []);

	const createMessageCenterCard = useCallback(async (formData: ICreateMessageCenterCardReq) => {
		const result = await postData({
			endpoint: `${urlPrefix}-createMessageCenterCard`,
			queryParams: {
				appName
			},
			body: {
				...formData,
				forwardReqRoute: '/helpdesk/createMessageCenterCard',
				forwardReqToService: SERVICE_NAMES.HELPDESK
			}
		});

		return result;
	}, []);

	const getMessageCenterCardCategories = useCallback(async () => {
		const result = await postData({
			endpoint: `${urlPrefix}-getMessageCenterCardCategories`,
			queryParams: {
				appName
			},
			body: { forwardReqRoute: '/helpdesk/getMessageCenterCardCategories', forwardReqToService: SERVICE_NAMES.HELPDESK }
		});

		return _get(result, ['data', 'categories']);
	}, []);

	const updateMessageCenterCard = useCallback(async (formData: IUpdateMessageCenterCardReq) => {
		const result = await postData({
			endpoint: `${urlPrefix}-updateMessageCenterCard`,
			queryParams: {
				appName
			},
			body: {
				...formData,
				forwardReqRoute: '/helpdesk/updateMessageCenterCard',
				forwardReqToService: SERVICE_NAMES.HELPDESK
			}
		});

		return result;
	}, []);

	const getMessageCenterCardCategoriesOption = async () => {
		return (await getMessageCenterCardCategories()).map((val: string) => ({ id: val, label: val }));
	};

	return {
		getAllCardsForMessageCenter,
		createMessageCenterCard,
		getMessageCenterCardCategories,
		updateMessageCenterCard,
		getMessageCenterCardCategoriesOption,
		deHydrateData,
		hydrateData
	};
};

export default useService;
